import { useState } from 'react';

export default function useSwitcher({ casesCount, getInitCase }) {
  const [switchCase, setSwitchCase] = useState(getInitCase);
  function nextCase() {
    setSwitchCase((switchCase + 1) % casesCount);
  }
  return [switchCase, nextCase];
}
